import './Tos.css';

export default function Tos() {
  return (
    <main>
      <section className="tos safearea">
        <h1>Terms of Service</h1>
        <div className="tos__content">
          <h2>1. Investment risk</h2>
          <p>Staking and investing in cryptocurrencies involves significant inherent risks. You should carefully consider your financial situation and risk tolerance before engaging in any staking activities. We are not responsible for any losses you may incur.</p>

          <h2>2. Acceptance of Terms</h2>
          <p>By accessing or using this website, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>

          <h2>3. Use License</h2>
          <p>Permission is granted to temporarily download one copy of the materials on this website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.</p>

          <h2>4. Disclaimer</h2>
          <p>The materials on this website are provided 'as is'. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties.</p>

          <h2>5. Limitations</h2>
          <p>In no event shall the website or its suppliers be liable for any damages arising out of the use or inability to use the materials on the website.</p>

          <h2>6. Modifications</h2>
          <p>We may revise these terms of service at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Service.</p>
        </div>
      </section>
    </main>
  );
}
